export const hours = Array.from(Array(24).keys());

export const minutes = Array(6)
  .fill(0)
  .map((_, idx) => idx * 10);
